module.exports = __webpack_public_path__ + "project-title.d36315a458f510c624f5.png";